module.exports = __webpack_public_path__ + "account/img/trip-choice__trip-preview-image.84303097.png";